export enum FeeManagementErrorCodes {
  FEE_CHARGE_ALREADY_APPLIED = 'fee_charge_alread_applied',
  FEE_CHARGE_ITEM_NOT_FOUND = 'fee_charge_item_not found',
  FEE_CHARGE_APPLY_PROCESS = 'fee_charge_apply_process',
  FEE_CHARGE_APPLY_PROCESS_CONFIG = 'fee_charge_apply_config_issue',
  FEE_CHARGE_REVERT_PROCESS = 'fee_charge_revert_process',
}
